import { Injectable } from '@angular/core';

export type LogViewerLog = { message: string; type: 'log' | 'warn' | 'error'; timestamp: string; expanded: boolean };

@Injectable({
    providedIn: 'root',
})
export class LoggingService {
    private logs: LogViewerLog[] = [];

    constructor() {
        if (false) {
            this.interceptConsoleLog();
            this.interceptConsoleWarn();
            this.interceptConsoleError();
        }
    }

    public clear(): void {
        this.logs = [];
    }

    public getLogs(): LogViewerLog[] {
        return this.logs;
    }

    private log(args: any[], type: 'log' | 'warn' | 'error'): void {
        const timestamp = new Date().toISOString();
        const formattedMessage = this.formatMessage(args);
        this.logs.unshift({ message: formattedMessage, type, timestamp, expanded: false });
    }

    private formatMessage(args: any[]): string {
        if (args.length === 0) {
            return '[]';
        }

        return args
            .map((arg) => {
                if (Array.isArray(arg) && arg.length === 0) {
                    return '[]';
                } else if (typeof arg === 'object') {
                    try {
                        return JSON.stringify(arg);
                    } catch {
                        return String(arg);
                    }
                } else {
                    return String(arg);
                }
            })
            .join(' ');
    }

    private interceptConsoleLog(): void {
        const originalConsoleLog = console.log;
        console.log = (...args) => {
            this.log(args, 'log');
            try {
                originalConsoleLog.apply(console, args);
            } catch {}
        };
    }

    private interceptConsoleWarn(): void {
        const originalConsoleWarn = console.warn;
        console.warn = (...args) => {
            this.log(args, 'warn');
            try {
                originalConsoleWarn.apply(console, args);
            } catch {}
        };
    }

    private interceptConsoleError(): void {
        const originalConsoleError = console.error;
        console.error = (...args) => {
            this.log(args, 'error');
            try {
                originalConsoleError.apply(console, args);
            } catch {}
        };
    }
}
